import { render, staticRenderFns } from "./AdminSermonView.vue?vue&type=template&id=a2042816&"
import script from "./AdminSermonView.vue?vue&type=script&lang=js&"
export * from "./AdminSermonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports